import useAxios from "axios-hooks"

export const useVenueAvailableSlots = (venueId) => {
  if (!venueId) {
    return { availableSlots: [], loading: false, refetch: () => {} }
  }
  var url = `${process.env.NEXT_PUBLIC_API_URL}/public/venues/${venueId}/availableSlots`

  const [{ data, loading, error }, refetch] = useAxios(
    { url },
    { useCache: false }
  )
  return { availableSlots: data, loading, refetch }
}
